'use strict';
import isFunction from 'lodash/isFunction';
import {Subject} from 'rxjs/Subject';
import {NoteState} from '../../system/enums/NoteState';

module.exports = [
  'FileUtilities',
  'NotificationService',
  FileStackNotificationsService];

function FileStackNotificationsService(
  FileUtilities,
  NotificationService,
) {
  const items = {};

  this.items = items; // for testing
  this.createNotification = createNotification;
  this.getCancelledBlobs = getCancelledBlobs;

  function createNotification(fpProgress, uploadRequest) {
    const fp = fingerprint(fpProgress);
    let note = items[fp];
    if (!note) {
      note = items[fp] = new FileStackNotification(fpProgress, fp, getDisplayName(fpProgress, uploadRequest));

      note.promise.then(function () {
        delete items[fp];
      });

      NotificationService.addNotification(note);
    }

    return note;
  }

  function getDisplayName(blob, uploadRequest) {
    const filename = isFunction(uploadRequest.getFilename) ? uploadRequest.getFilename() : uploadRequest.filename;

    return filename + '.' + FileUtilities.getExtension(blob.filename);
  }

  // return all blobs that were picked but are not found in the final blobs list
  // these need to be removed from the system
  function getCancelledBlobs(blobs) {
    const missing = [];
    const blobsFps = fingerprintBlobs(blobs);

    for (const fp in items) {
      if (items.hasOwnProperty(fp) && !blobsFps.hasOwnProperty(fp)) {
        missing.push(items[fp]);
        NotificationService.removeNotification(items[fp].__noteId);
        delete items[fp];
      }
    }

    return missing;
  }

  function fingerprintBlobs(blobs) {
    const fps = {};
    for (const key in blobs) {
      if (blobs.hasOwnProperty(key)) {
        fps[fingerprint(blobs[key])] = blobs[key];
      }
    }

    return fps;
  }

  function FileStackNotification(fpProgress, fp, filename) {
    this.__fingerprint = fp;
    this.deferred = Promise.defer();

    this.name = `Uploading ${filename}`;
    this.getNameFromState = (prevNote, nextNote) => {
      switch (nextNote.__noteState) {
        case NoteState.ERROR:
          return `Failed to upload ${filename}`;

        case NoteState.PROGRESS:
        case NoteState.INDEFINITE:
        case NoteState.INFO:
          return `Uploading ${filename}`;

        case NoteState.COMPLETE:
          return `Uploaded ${filename}`;
      }
    };
    this.mimetype = fpProgress.mimetype;
    this.size = fpProgress.size;
    this.removal = NotificationService.REMOVAL.NEVER;
    this.promise = this.deferred.promise;
    this.progress = this.progressSubject = new Subject();
    this.toasts = {
      [NoteState.ERROR]: true,
    };
  }

  function fingerprint(fpProgress) {
    return fpProgress.filename + fpProgress.mimetype + fpProgress.size;
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/notifications/FileStackNotificationsService.js